require("bootstrap");
import Viewer from 'viewerjs';

(function($) {
    "use strict";

    const galleryTitle = new Viewer(document.getElementById("image-viewer-title"));
    const galleryContent = new Viewer(document.getElementById("image-viewer-content"));

    function youtube_parser(url) {
        var regExp =
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return match && match[7].length == 11 ? match[7] : false;
    }

    $(document).ready(() => {
        $(".content")
            .find("a")
            .each(function() {
                let href = $(this).attr("href");
                if (youtube_parser(href)) {
                    let src =
                        "https://www.youtube.com/embed/" + youtube_parser(href);
                    $(this)
                        .closest("p")
                        .append(
                            '<iframe width="600" height="345" src="' +
                            src +
                            '"></iframe>'
                        );
                    $(this).remove();
                }
            });
    });

    $(document).on("click", ".btn-close-alert", function() {
        $(this).parents(".alert").addClass("notransition");
    });

    $(".btn-close").on("click", function(e) {
        $("#modal").modal("hide");
    });

    $(document).on("click", ".btn-add-favorite", function() {
        $(this).css("pointer-events", "none");
        let url = $(this).data("url");
        let id = $(this).data("id");
        updateFavorite(url, id);
        $(this).css("pointer-events", "all");
    });

    var updateFavorite = function(url, id) {
        let favoriteStorage = getFavoriteStorage();
        let btnCurrentStateFavorite;

        if (favoriteStorage.indexOf(id) > -1) {
            btnCurrentStateFavorite = 0;
            favoriteStorage.splice(favoriteStorage.indexOf(id), 1);
        } else {
            btnCurrentStateFavorite = 1;
            favoriteStorage.push(id);
        }

        localStorage.setItem('qa_user_favorite', JSON.stringify(favoriteStorage));

        let param = {
            isFavorite: btnCurrentStateFavorite,
            favoriteIds: favoriteStorage
        }

        $.ajaxSetup({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        });
        $.ajax({
            url: url,
            type: "POST",
            async: false,
            data: param,
            success: function(res, sec) {
                $(".btn-add-favorite").toggleClass("active");
            },
            error: function(res, sec) {},
        });
    };

    $(document).on("click", ".btn-update-questionnaire", function() {
        let url = $(this).data("url");
        $(this).css("pointer-events", "none");
        let value = $(this).data("value");
        let param = {
            status: value,
        };
        updateQuestionnaireStatus(url, $(this), param);
        $(this).data("value", 1 - $(this).data("value"));
        $(this).css("pointer-events", "all");
    });

    var updateQuestionnaireStatus = function(url, _this, param) {
        $.ajaxSetup({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        });

        $.ajax({
            url: url,
            type: "POST",
            data: param,
            async: false,
            success: function(res, sec) {
                if (res) {
                    $(".btn-update-questionnaire").toggleClass("active");
                    _this.css("pointer-events", "all");
                    let alert = $(".alert.alert-update-questionnaire");
                    if (alert.length) {
                        $(".alert.alert-update-questionnaire").removeClass(
                            "show-alert"
                        );
                        setTimeout(() => {
                            $(".alert.alert-update-questionnaire")
                                .addClass("show-alert")
                                .removeClass("notransition");
                        }, 300);
                    }
                }
            },
            error: function(res, sec) {},
        });
    };

    $(document).on("click", ".btn-submit-question", function() {
        let url = $(this).data("url");
        let content = $("#comment").val();
        let param = {
            content: content,
        };
        submitFormQuestionnaire(url, param);
    });

    var submitFormQuestionnaire = function(url, param) {
        $.ajaxSetup({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
        });
        $.ajax({
            url: url,
            type: "POST",
            async: false,
            data: param,
            success: function(res, sec) {
                $(".error").remove();
                $("#comment").val("");
                let alert = $(".alert.alert-questionnaire");
                if (alert.length == 0) {
                    $(".question .right").append(
                        '<div class="alert alert-questionnaire show-alert">' +
                        '<p class="mb-0">' +
                        "ご意見ご感想ありがとうございます。" +
                        "</p>" +
                        '<button type="button" class="btn-icon material-icons btn-close-alert">close</button>' +
                        "</div>"
                    );
                }
                $(".alert.alert-questionnaire").removeClass("show-alert");
                setTimeout(() => {
                    $(".alert.alert-questionnaire")
                        .addClass("show-alert")
                        .removeClass("notransition");
                }, 300);
            },
            error: function(res, sec) {
                $(".error").remove();
                if (res.status == 422) {
                    let dataErrors = res.responseJSON.errors;
                    if (Object.keys(dataErrors).length > 0) {
                        for (const [key, value] of Object.entries(dataErrors)) {
                            $('[name="' + key + '"]')
                                .parents(".form-group")
                                .append(
                                    '<div class="error">' + value[0] + "</div>"
                                );
                        }
                    }
                } else {
                    $(".error").remove();
                }
                $(".alert.alert-questionnaire").addClass("notransition");
            },
        });
    };

    function setFavorite() {
        let qaFavoriteStorageIds = getFavoriteStorage();
        $(".btn-add-favorite").each(function(item) {
            let id = $(this).data('id');
            if (qaFavoriteStorageIds.includes(id)) {
                $(this).toggleClass('active');
            }
        })
    }

    setFavorite();

    function getFavoriteStorage() {
        let favoriteStorage = localStorage.getItem("qa_user_favorite");
        if (favoriteStorage) {
            favoriteStorage = JSON.parse(favoriteStorage);
        } else {
            favoriteStorage = [];
        }
        return favoriteStorage;
    }
})(jQuery);
